module.exports = __webpack_public_path__ + "ultimate-edition.png";